import { CustomHandle } from '~/utils/CustomHandle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Node de Fim
export const FimNode = ({ data }) => (
    <div className={`node-fim ${data.highlighted ? 'highlighted' : ''}`}>
        <FontAwesomeIcon icon="fa-solid fa-stop" className="node-icon" />
        <span className="node-text">{data.label}</span>
        <CustomHandle type="target" position="top" />
    </div>
);
